import { render, staticRenderFns } from "./salInsured.vue?vue&type=template&id=2f8678ed&scoped=true&"
import script from "./salInsured.vue?vue&type=script&lang=js&"
export * from "./salInsured.vue?vue&type=script&lang=js&"
import style0 from "./salInsured.vue?vue&type=style&index=0&id=2f8678ed&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8678ed",
  null
  
)

export default component.exports